export const menuItemHeightSmall = 32;
export const menuItemHeight = 36;
export const menuItemHeightLarge = 40;

export interface IMenuAction {
  id: any;
  label: any;
  icon?: any;
  path?: string;
  subMenu?: IMenuAction[];
  root?: string;
  disabled?: boolean;
  description?: string;
}
